import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'

import { IonicModule } from '@ionic/angular'

import { PushEjecucionPage } from './push-ejecucion.page'


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  declarations: [
    PushEjecucionPage
  ],
  exports: [ ]
})
export class PushEjecucionPageModule {}
